module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-step-2__col order-step-2__col-2"
  }, [_c('div', {
    staticClass: "order-step-2__col-2-header"
  }, [_c('h3', {
    staticClass: "order-step-2__col-2-heading"
  }, [_vm._v("Unser Appetit")]), _vm._v(" "), _c('a', {
    staticClass: "order-step-2__col-2-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleInfoModalVisible("\n                <div class='text-container'>\n                    <h3>Was bedeuten die Mengenangaben Chasperli, Öpfelchasper und Superchasper?</h3>\n                    <p>Unsere Mengenangaben stützen sich auf die Empfehlungen der Schweizerischen Gesellschaft für Ernährung. So sollte eine erwachsene Person täglich 5 Portionen Früchte und Gemüse in verschiedenen Farben zu sich nehmen, wobei 1 Portion rund 120 g entspricht. Pro Woche ist dies eine Gesamtmenge von 4.2 kg Gemüse und Früchte pro Person.\n                        <br/><br/>\n                        Das Abo «Bio fürs Büro» kann somit folgenden Bedarf an Früchten und/oder Gemüse decken:\n                        <br/><br/>\n                        Chasperli: 400 g pro Person und Woche (ca. 3 Portionen)<br/>\n                        Öpfelchasper: 600 g pro Person und Woche (ca. 5 Portionen)<br/>\n                        Superchasper: 800 g pro Person und Woche (ca. 7 Portionen)\n                    </p>\n                </div>")
      }
    }
  }, [_vm._v("\n            Was bedeutet das?\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "appetite-options"
  }, _vm._l((_vm.appetites), function(a, index) {
    return _c('label', {
      key: a.id,
      class: ['appetite-options__label', ("appetite-options__label-" + (index + 1)), _vm.activeAppetite === a.name ? 'appetite-options__label--active' : '']
    }, [_c('input', {
      staticClass: "appetite-options__input",
      attrs: {
        "name": "appetite",
        "type": "radio"
      },
      domProps: {
        "value": a.name
      },
      on: {
        "change": function($event) {
          return _vm.updateAppetite(a.name, _vm.mode)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sr-only"
    }, [_vm._v(_vm._s(a.name))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94f0fc5e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Appetite.vue
// module id = 737
// module chunks = 0